import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TargetSelectorColumn = styled(Box)(({ theme }) => ({
  minWidth: '320px',
  maxWidth: '320px',
  padding: theme.spacing(1),
}));

export const ResultColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '45%',
  padding: theme.spacing(2, 1, 1),
}));

export const DateSelectRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  margin: theme.spacing(0, 0, 2),
}));
